/**
 * 黄色 banner — 表示当前页正在用 mock 数据（API 未就绪 / 失败时降级）。
 * 提炼自 Overview，多页复用。
 */

interface MockBannerProps {
  /** 简短文案（API endpoint 名 + 状态） */
  message?: string;
}

export default function MockBanner({
  message = '当前显示模拟数据 · 真 API 暂时不可用',
}: MockBannerProps) {
  return (
    <div
      className="rounded-lg border px-4 py-2.5 text-[13px] flex items-center gap-2"
      style={{ background: '#FFFBEB', borderColor: '#FCD34D', color: '#92400E' }}
    >
      <span>ℹ️</span>
      <span>{message}</span>
    </div>
  );
}
